<template>
  <PageTitle :title="content.videos" :parentTitle="content.mediaAndArchive">
    <div class="flex items-center">

      <!-- <YearDropdown @setYear="setYear"></YearDropdown> -->
    </div>
  </PageTitle>
  <div class="grid grid-cols-12 mt-8 layout-padding lg:gap-x-10">
    <div class="lg:col-span-7 col-span-12 ">
      <div class="all-videos mb-20">
        <div class="video-thumb group cursor-pointer h-[430px]"
          :style="`background:url(${archives[selectedVideo]?.image})`">


          <iframe width="100%" height="430" v-if="youtube" :src="`https://www.youtube.com/embed/${videoId}`"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen></iframe>
        </div>
        <div class="text-2xl lg:my-5 mt-5 ">
          {{ archives[selectedVideo]?.title }}
        </div>
        <div class="mb-5">{{ archives[selectedVideo]?.year }}</div>
        <div class="mb-20" v-html="archives[selectedVideo]?.description"></div>
      </div>
    </div>
    <div class="  lg:col-span-5 col-span-12 min-h-screen">
      <div class=" overflow-x-hidden  mb-8">

        <VideoCard @click="selectedVideo = index" v-for="video, index in archives" :video="video" :key="video" />

      </div>
    </div>
  </div>
</template>

<script>
import VideoCard from "/src/components/UI/Cards/VideoCard.vue";
export default {
  inject: ['content'],
  data() {
    return {
      oldLength: 0,
      videoId: null,
      selectedYear: null,
      selectedVideo: 0,
      youtube: true,
    }
  },
  components: {
    VideoCard,
  },
  computed: {
    archives() {
      return this.$store.getters["archive/archive"];
    },
    noResults() {
      return this.$store.getters["archive/noResult"];
    },
    allArchivesLoaded() {
      return this.$store.getters["archive/allArchivesLoaded"];
    },
  },
  mounted() {
    this.loadData();

  },
  watch: {
    selectedYear() {
      this.$store.dispatch("archive/resetArchive");
      this.loadData();
    },
    selectedVideo() {
      this.videoId = this.getVideoId(this.archives[this.selectedVideo]?.link)

      this.youtube = false;
      setTimeout(() => {
        this.youtube = true;
      }, 50);
    },
    archives() {
      if (this.archives.length > 0) {
        if (this.$route.query.videoId) {
          this.videoId = this.$route.query.videoId;
          this.selectedVideo = this.archives.findIndex(
            (archive) => this.getVideoId(archive.link) === this.videoId
          );
        } else {
          this.videoId = this.getVideoId(this.archives[this.selectedVideo]?.link)
        }
      }
    }
  },
  methods: {
    setYear(year) {
      this.selectedYear = year;
    },
    getVideoId(link) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      var match = link.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    },
    async loadData() {

      if (this.$route.query.type != "all") {
        this.oldLength = this.archives.length;
        await this.$store.dispatch("archive/filterArchive", {
          type: 'videos',
          year: this.selectedYear == null ? "all" : this.selectedYear,
        });
      }
    },
  },

};
</script>

